// extracted by mini-css-extract-plugin
export var active = "_lg-2";
export var recordingDot = "_lg-1";
export var recordingIndicator = "_lg-0";